import { ImportTypes, StageTypes } from './schemas/StageSchema'

export const REDUCER_INDEX = 'tournaments_v2'

export const STAGES_TYPES_NAMES: { [key in StageTypes]: string } = {
  [StageTypes.ALL]: 'Todos contra Todos',
  [StageTypes.TYPE_ELIMINATION]: 'Eliminación',
  [StageTypes.TYPE_GROUPS]: 'Grupos',
}

export const IMPORT_TYPES_NAMES: { [key in ImportTypes]: string } = {
  [ImportTypes.TYPE_COMET]: 'Comet',
  [ImportTypes.TYPE_FCF]: 'Federación Colombiana de Fútbol',
  [ImportTypes.TYPE_LFB]: 'Liga de fútbol de Bogotá',
}
